import { render, staticRenderFns } from "./filePreview.vue?vue&type=template&id=859d6cb0&"
import script from "./filePreview.vue?vue&type=script&scoped=true&lang=js&"
export * from "./filePreview.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./filePreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports